/* Modern KS BootShop JavaScript Enhancements */

// Enhanced scroll animations
function initScrollAnimations() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    });
  }, observerOptions);

  // Observe elements for animation
  const animatedElements = document.querySelectorAll(
    '.product-card, .collection-card, .testimonial-card, .card'
  );
  
  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

// Enhanced hover effects
function initHoverEffects() {
  const cards = document.querySelectorAll('.product-card, .collection-card, .card');
  
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.transform = 'translateY(-8px) scale(1.02)';
      card.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
    });
    
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'translateY(0) scale(1)';
      card.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
    });
  });
}

// Smooth scrolling for anchor links
function initSmoothScrolling() {
  const links = document.querySelectorAll('a[href^="#"]');
  
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Enhanced carousel controls
function initCarouselEnhancements() {
  const carousels = document.querySelectorAll('.carousel');
  
  carousels.forEach(carousel => {
    // Add touch/swipe support
    let startX = 0;
    let endX = 0;
    
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });
    
    carousel.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      handleSwipe();
    });
    
    function handleSwipe() {
      const threshold = 50;
      const diff = startX - endX;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          // Swipe left - next slide
          const nextBtn = carousel.querySelector('.carousel-control-next');
          if (nextBtn) nextBtn.click();
        } else {
          // Swipe right - previous slide
          const prevBtn = carousel.querySelector('.carousel-control-prev');
          if (prevBtn) prevBtn.click();
        }
      }
    }
  });
}

// Loading animations for images
function initLoadingAnimations() {
  const images = document.querySelectorAll('img');
  
  images.forEach(img => {
    if (!img.complete) {
      img.classList.add('loading-shimmer');
      
      img.addEventListener('load', () => {
        img.classList.remove('loading-shimmer');
        img.classList.add('loaded');
      });
    } else {
      img.classList.add('loaded');
    }
  });
}

// Enhanced form interactions
function initFormEnhancements() {
  const forms = document.querySelectorAll('form');
  
  forms.forEach(form => {
    const inputs = form.querySelectorAll('input, textarea, select');
    
    inputs.forEach(input => {
      input.addEventListener('focus', () => {
        input.parentElement.classList.add('focused');
      });
      
      input.addEventListener('blur', () => {
        if (!input.value) {
          input.parentElement.classList.remove('focused');
        }
      });
    });
  });
}

// Newsletter form enhancement
function initNewsletterForm() {
  const newsletterForm = document.querySelector('.newsletter form');
  if (!newsletterForm) return;

  const input = newsletterForm.querySelector('input[type="email"]');
  const button = newsletterForm.querySelector('button[type="submit"]');

  if (input && button) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      // Add loading state
      button.classList.add('loading');
      button.textContent = 'Subscribing...';
      
      // Simulate API call (replace with actual implementation)
      setTimeout(() => {
        button.classList.remove('loading');
        button.textContent = 'Subscribed!';
        
        setTimeout(() => {
          button.textContent = 'Subscribe';
          input.value = '';
        }, 2000);
      }, 1000);
    });
  }
}

// Product quick add enhancement
function initProductQuickAdd() {
  const quickAddButtons = document.querySelectorAll('.quick-add-btn, .btn-add-to-cart');
  
  quickAddButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Add loading animation
      button.classList.add('loading');
      button.textContent = 'Adding...';
      
      // Simulate API call (replace with actual implementation)
      setTimeout(() => {
        button.classList.remove('loading');
        button.textContent = 'Added!';
        
        setTimeout(() => {
          button.textContent = 'Add to Cart';
        }, 2000);
      }, 1000);
    });
  });
}

// Initialize all enhancements when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initHoverEffects();
  initSmoothScrolling();
  initCarouselEnhancements();
  initLoadingAnimations();
  initFormEnhancements();
  initNewsletterForm();
  initProductQuickAdd();
  initCustomJudaica();
});

// Add CSS for loading states
const style = document.createElement('style');
style.textContent = `
  .loading {
    position: relative;
    overflow: hidden;
  }
  
  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    animation: loading 1.5s infinite;
  }
  
  @keyframes loading {
    0% { left: -100%; }
    100% { left: 100%; }
  }
  
  .focused input {
    transform: scale(1.05);
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
  }
  
  .loaded {
    animation: imageLoad 0.5s ease-out;
  }
  
  @keyframes imageLoad {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

document.head.appendChild(style);

// Custom Judaica Configurator
function initCustomJudaica() {
  const root = document.getElementById('cj-configurator');
  if (!root) return;

  const productSelect = document.getElementById('cj-product-select');
  const productItems = root.querySelectorAll('.cj-product-item');
  const productSelectBtns = root.querySelectorAll('.cj-product-select-btn');
  const productImageWrap = document.getElementById('cj-product-image-wrap');
  const productImageEl = document.getElementById('cj-product-image');
  const qtyInput = document.getElementById('cj-qty');
  const minQty = parseInt(root.getAttribute('data-min-qty') || '70', 10);
  const priceEl = document.getElementById('cj-price');
  const addBtn = document.getElementById('cj-add-to-cart');
  const swatches = root.querySelectorAll('.cj-swatch');
  const materialHidden = document.getElementById('cj-material');
  const embossUploadRadio = document.getElementById('cj-emboss-upload');
  const embossTextRadio = document.getElementById('cj-emboss-text');
  const uploadPanel = document.getElementById('cj-emboss-upload-panel');
  const textPanel = document.getElementById('cj-emboss-text-panel');
  const fileInput = document.getElementById('cj-file');
  const textInput = document.getElementById('cj-text');

  // Uplift bounds (percent)
  const upliftMin = parseInt(root.getAttribute('data-uplift-min') || '10', 10);
  const upliftMax = parseInt(root.getAttribute('data-uplift-max') || '20', 10);

  let state = {
    variantId: null,
    productTitle: null,
    basePrice: null, // in cents if available, else number
    upliftPercent: upliftMin,
    quantity: Math.max(minQty, parseInt(qtyInput.value || '0', 10) || minQty),
    material: '',
    embossMode: 'upload',
    embossText: '',
    hasFile: false
  };

  // Restore from session
  try {
    const saved = sessionStorage.getItem('cj_state');
    if (saved) {
      const parsed = JSON.parse(saved);
      state = { ...state, ...parsed };
      // Reflect to inputs
      if (state.variantId) {
        const card = Array.from(productItems).find(b => (b.getAttribute('data-variant-id') || '') === String(state.variantId));
        if (card) {
          // Emulate selection
          productItems.forEach(b => b.classList.remove('selected'));
          card.classList.add('selected');
          const img = card.getAttribute('data-product-image') || '';
          if (img) {
            if (productImageEl) productImageEl.src = img;
            if (productImageWrap) {
              const s = getCurrentStepFromURL ? getCurrentStepFromURL() : 1;
              productImageWrap.style.display = s >= 2 ? '' : 'none';
            }
          }
        }
      }
      if (state.quantity) qtyInput.value = String(state.quantity);
      if (state.material) {
        materialHidden.value = state.material;
        root.querySelectorAll('.cj-swatch').forEach(b => {
          if ((b.getAttribute('data-value') || '') === state.material) b.classList.add('selected');
        });
      }
      if (state.embossMode === 'text') embossTextRadio.checked = true; else embossUploadRadio.checked = true;
      refreshEmbossPanels();
      if (state.embossText) textInput.value = state.embossText;
    }
  } catch (e) {}

  function persistState() {
    try { sessionStorage.setItem('cj_state', JSON.stringify(state)); } catch (e) {}
  }
  
  // Expose functions for dynamically added swatches
  window.cj_updateMaterial = function(value) {
    let normalized = (value == null) ? '' : String(value).trim();
    if (!normalized) normalized = 'Selected Material';
    state.material = normalized;
    if (materialHidden) materialHidden.value = normalized;
    persistState();
    updateUI();
    if (getCurrentStepFromURL() === 4) renderStep4Summary();
    // If currently on step 3, auto-advance to step 4
    const step = getCurrentStepFromURL();
    console.log('CJ: cj_updateMaterial -> material:', state.material, 'current step:', step);
    if (step === 3 && state.material) {
      setTimeout(() => {
        console.log('CJ: Advancing to step 4 after cj_updateMaterial');
        goToStep(4);
      }, 50);
    }
  };
  
  // Expose state check function for debugging
  window.cj_getState = function() {
    return state;
  };

  // Helper: extract material value from a swatch button robustly
  function getMaterialValueFromSwatch(btn) {
    if (!btn) return '';
    const fromData = (btn.getAttribute('data-value') || '').trim();
    if (fromData) return fromData;
    const fromAria = (btn.getAttribute('aria-label') || '').trim();
    if (fromAria) return fromAria;
    const img = btn.querySelector('img');
    if (img) {
      const alt = (img.getAttribute('alt') || '').trim();
      if (alt) return alt;
    }
    const text = (btn.textContent || '').trim();
    return text;
  }

  // Swatch selection - attach to initial swatches
  function attachSwatchHandlers() {
    const allSwatches = root.querySelectorAll('.cj-swatch');
    console.log('CJ: Attaching handlers to', allSwatches.length, 'swatches');
    
    allSwatches.forEach((btn) => {
      // Remove old handler if exists
      const oldHandler = btn._cj_handler;
      if (oldHandler) {
        btn.removeEventListener('click', oldHandler);
      }
      
      // Create new handler
      const handler = function() {
        allSwatches.forEach(b => b.classList.remove('selected', 'active'));
        btn.classList.add('selected', 'active');
        let value = getMaterialValueFromSwatch(btn);
        if (!value) {
          const img = btn.querySelector('img');
          if (img && img.src) {
            try { value = decodeURIComponent(img.src.split('/').pop().split('?')[0]) || ''; } catch (e) {}
          }
        }
        if (!value) value = 'Selected Material';
        state.material = value;
        if (materialHidden) materialHidden.value = value;
        console.log('CJ: Swatch selected -> extracted value:', value);
        persistState();
        updateUI();
        if (getCurrentStepFromURL() === 4) renderStep4Summary();
        // If currently on step 3, auto-advance to step 4
        const step = getCurrentStepFromURL();
        console.log('CJ: Swatch selected -> material:', state.material, 'current step:', step);
        if (step === 3 && state.material) {
          setTimeout(() => {
            console.log('CJ: Advancing to step 4 after material select');
            goToStep(4);
          }, 50);
        }
      };
      
      btn._cj_handler = handler;
      btn.addEventListener('click', handler);
    });
  }
  
  // Initial attachment
  attachSwatchHandlers();
  
  // Expose reinit function for dynamically added swatches
  window.cj_reinitSwatches = function() {
    console.log('CJ: Reinitializing swatch handlers');
    attachSwatchHandlers();
  };

  // Emboss mode toggles
  function refreshEmbossPanels() {
    if (embossUploadRadio.checked) {
      state.embossMode = 'upload';
      uploadPanel.classList.remove('d-none');
      textPanel.classList.add('d-none');
    } else {
      state.embossMode = 'text';
      uploadPanel.classList.add('d-none');
      textPanel.classList.remove('d-none');
    }
    persistState();
    updateUI();
  }
  embossUploadRadio.addEventListener('change', refreshEmbossPanels);
  embossTextRadio.addEventListener('change', refreshEmbossPanels);
  refreshEmbossPanels();

  // Product selection via cards
  function selectProductByElement(el) {
    if (!el) return;
    productItems.forEach(b => b.classList.remove('selected'));
    el.classList.add('selected');
    const variantId = el.getAttribute('data-variant-id') || '';
    const title = el.getAttribute('data-product-title') || '';
    const priceStr = el.getAttribute('data-product-price') || '';
    const img = el.getAttribute('data-product-image') || '';
    state.variantId = variantId;
    state.productTitle = title;
    const parsed = parseFloat(priceStr.toString().replace(/[^0-9.]/g, ''));
    state.basePrice = isNaN(parsed) ? null : parsed;
    if (img) {
      if (productImageEl) productImageEl.src = img;
      if (productImageWrap) {
        const s = getCurrentStepFromURL ? getCurrentStepFromURL() : 1;
        productImageWrap.style.display = s >= 2 ? '' : 'none';
      }
    } else if (productImageWrap) {
      productImageWrap.style.display = 'none';
    }
    const upliftAttr = el.getAttribute('data-uplift');
    if (upliftAttr) {
      const u = parseInt(upliftAttr, 10);
      if (!isNaN(u)) state.upliftPercent = u; else state.upliftPercent = upliftMin;
    } else {
      state.upliftPercent = upliftMin;
    }
    persistState();
    updateUI();
    if (getCurrentStepFromURL() === 4) renderStep4Summary();
  }
  productItems.forEach((card) => {
    card.addEventListener('click', (e) => {
      // Ignore clicks on inner Select button to prevent double-advance
      if (e.target && e.target.closest('.cj-product-select-btn')) return;
      selectProductByElement(card);
    });
  });
  // Clicking the explicit Select button chooses and advances to next step
  // Fallback if select exists (legacy)
  if (productSelect) {
    productSelect.addEventListener('change', () => {
      const opt = productSelect.selectedOptions && productSelect.selectedOptions[0];
      if (!opt) return;
      const mock = {
        getAttribute: (k) => {
          if (k === 'data-variant-id') return opt.value;
          return opt.getAttribute(k);
        },
        classList: { add() {}, remove() {} }
      };
      selectProductByElement(mock);
    });
  }

  // Quantity enforcement
  qtyInput.addEventListener('input', () => {
    const val = parseInt(qtyInput.value || '0', 10);
    const numeric = isNaN(val) ? 0 : val;
    state.quantity = numeric;

    // Live validation feedback without clamping
    const help = document.getElementById('cj-qty-help');
    if (numeric < minQty) {
      if (help) {
        help.textContent = `Minimum order quantity is ${minQty} units.`;
        help.classList.add('text-danger');
      }
      qtyInput.classList.add('is-invalid');
    } else {
      if (help) {
        help.textContent = `Minimum order quantity is ${minQty} units.`;
        help.classList.remove('text-danger');
      }
      qtyInput.classList.remove('is-invalid');
    }

    persistState();
    updateUI();
    if (getCurrentStepFromURL() === 4) renderStep4Summary();
  });

  // Clamp to minimum on blur for consistency
  qtyInput.addEventListener('blur', () => {
    const val = parseInt(qtyInput.value || '0', 10);
    const numeric = isNaN(val) ? 0 : val;
    if (numeric < minQty) {
      state.quantity = minQty;
      qtyInput.value = String(minQty);
      qtyInput.classList.remove('is-invalid');
      const help = document.getElementById('cj-qty-help');
      if (help) help.classList.remove('text-danger');
      persistState();
      updateUI();
      if (getCurrentStepFromURL() === 4) renderStep4Summary();
    }
  });

  // File/text inputs
  fileInput.addEventListener('change', () => {
    state.hasFile = fileInput.files && fileInput.files.length > 0;
    persistState();
    updateUI();
  });
  textInput.addEventListener('input', () => {
    state.embossText = textInput.value || '';
    persistState();
    updateUI();
  });

  // Add to cart
  addBtn.addEventListener('click', () => {
    if (!canSubmit()) return;
    submitToCart();
  });

  function calculateAdjustedUnitPrice() {
    if (state.basePrice == null) return null;
    // If base price is in shop currency units (e.g., 12.34), convert to cents if Shopify.formatMoney expects cents
    const isCents = state.basePrice > 1000; // heuristic; if provided as "money_without_currency" it is units, not cents
    const baseInUnits = isCents ? (state.basePrice / 100) : state.basePrice;
    const uplift = Math.min(Math.max(state.upliftPercent, upliftMin), upliftMax);
    const adjusted = baseInUnits * (1 + uplift / 100);
    return adjusted;
  }

  function formatMoney(amountInUnits) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        // Convert to cents as expected by formatMoney
        const cents = Math.round(amountInUnits * 100);
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD' }).format(amountInUnits);
  }

  function canSubmit() {
    if (!state.variantId) return false;
    if (!state.material) return false;
    if (!state.quantity || state.quantity < minQty) return false;
    if (state.embossMode === 'upload' && !state.hasFile) return false;
    if (state.embossMode === 'text' && !state.embossText.trim()) return false;
    return true;
  }

  // Step-by-step navigation
  const steps = Array.from(root.querySelectorAll('.cj-step'));
  const prevBtn = document.getElementById('cj-prev');
  const nextBtn = document.getElementById('cj-next');
  const indicators = Array.from(root.querySelectorAll('[data-step-indicator]'));

  function getCurrentStepFromURL() {
    const url = new URL(window.location.href);
    const s = parseInt(url.searchParams.get('step') || '1', 10);
    return Math.min(Math.max(s, 1), 5);
  }

  function setStepInURL(step) {
    const url = new URL(window.location.href);
    url.searchParams.set('step', String(step));
    history.replaceState({}, '', url.toString());
  }

  function stepIsValid(step) {
    switch (step) {
      case 1: return Boolean(state.variantId);
      case 2: return Boolean(state.quantity) && state.quantity >= minQty;
      case 3: return Boolean(state.material);
      case 4: return state.embossMode === 'upload' ? state.hasFile : Boolean(state.embossText.trim());
      case 5: return canSubmit();
      default: return false;
    }
  }

  function updateIndicators(activeStep) {
    indicators.forEach(el => {
      const s = parseInt(el.getAttribute('data-step-indicator') || '0', 10);
      el.classList.toggle('text-primary', s === activeStep);
      el.classList.toggle('fw-semibold', s === activeStep);
    });
  }

  function renderStep4Summary() {
    const productEl = document.getElementById('cj-summary-product');
    const qtyEl = document.getElementById('cj-summary-qty');
    const materialEl = document.getElementById('cj-summary-material');
    if (!productEl || !qtyEl || !materialEl) return;
    productEl.textContent = state.productTitle || (state.variantId ? 'Selected product' : '—');
    qtyEl.textContent = state.quantity ? String(state.quantity) : '—';
    materialEl.textContent = state.material || '—';
  }

  function showStep(step) {
    steps.forEach(el => {
      const s = parseInt(el.getAttribute('data-step') || '0', 10);
      el.style.display = (s === step) ? '' : 'none';
    });
    prevBtn.disabled = step === 1;
    nextBtn.textContent = step === 5 ? 'Done' : 'Next';
    nextBtn.disabled = !stepIsValid(step);
    updateIndicators(step);
    // Hide preview on step 1, show on later steps when available
    if (productImageWrap) {
      if (step === 1) {
        productImageWrap.style.display = 'none';
      } else if (productImageEl && productImageEl.getAttribute('src')) {
        productImageWrap.style.display = '';
      }
    }
    if (step === 4) {
      renderStep4Summary();
    }
  }

  function goToStep(step) {
    const bounded = Math.min(Math.max(step, 1), 5);
    setStepInURL(bounded);
    showStep(bounded);
  }

  // Sync next button enabled state as inputs change
  const observeInputs = [productSelect, qtyInput, fileInput, textInput, materialHidden, ...productItems].filter(Boolean);
  observeInputs.forEach(el => {
    el.addEventListener('input', () => {
      const step = getCurrentStepFromURL();
      nextBtn.disabled = !stepIsValid(step);
    });
    el.addEventListener('change', () => {
      const step = getCurrentStepFromURL();
      nextBtn.disabled = !stepIsValid(step);
    });
  });

  prevBtn.addEventListener('click', () => {
    const step = getCurrentStepFromURL();
    goToStep(step - 1);
  });
  nextBtn.addEventListener('click', () => {
    const step = getCurrentStepFromURL();
    if (step === 5) return; // no-op; Add to Cart handles final action
    if (!stepIsValid(step)) return;
    goToStep(step + 1);
  });

  // Product "Select" buttons should choose the product and advance to Step 2
  productSelectBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const card = btn.closest('.cj-product-item');
      if (card) selectProductByElement(card);
      goToStep(2);
    });
  });

  function updateUI() {
    const adjustedUnit = calculateAdjustedUnitPrice();
    const total = adjustedUnit == null ? null : (adjustedUnit * (state.quantity || 0));
    priceEl.textContent = total == null ? '—' : formatMoney(total);
    addBtn.disabled = !canSubmit();
    
    // Update Next button state based on current step (avoid TDZ by querying locally)
    const currentStep = getCurrentStepFromURL();
    const nextButtonLocal = document.getElementById('cj-next');
    if (nextButtonLocal) {
      nextButtonLocal.disabled = !stepIsValid(currentStep);
    }
    if (currentStep === 4) {
      renderStep4Summary();
    }
  }

  function submitToCart() {
    // Prefer multipart form submission to support file upload as line item property
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    form.enctype = 'multipart/form-data';
    form.className = 'visually-hidden';

    const idInput = document.createElement('input');
    idInput.name = 'id';
    idInput.value = state.variantId;
    form.appendChild(idInput);

    const qty = document.createElement('input');
    qty.name = 'quantity';
    qty.type = 'number';
    qty.value = String(state.quantity);
    form.appendChild(qty);

    // Line item properties
    const propMaterial = document.createElement('input');
    propMaterial.name = 'properties[Material]';
    propMaterial.value = state.material;
    form.appendChild(propMaterial);

    const propMode = document.createElement('input');
    propMode.name = 'properties[Embossing Mode]';
    propMode.value = state.embossMode === 'upload' ? 'Upload PDF' : 'Text';
    form.appendChild(propMode);

    const propUplift = document.createElement('input');
    propUplift.name = 'properties[Custom Cover Uplift %]';
    propUplift.value = String(state.upliftPercent);
    form.appendChild(propUplift);

    if (state.embossMode === 'text') {
      const propText = document.createElement('input');
      propText.name = 'properties[Embossing Text]';
      propText.value = state.embossText;
      form.appendChild(propText);
    } else if (state.embossMode === 'upload' && fileInput.files && fileInput.files[0]) {
      // Attach file input (Shopify will handle upload and attach URL in admin/orders)
      const cloned = fileInput.cloneNode(true);
      cloned.name = 'properties[Embossing File]';
      form.appendChild(cloned);
    }

    document.body.appendChild(form);
    form.submit();
  }

  // Initial UI
  updateUI();
  showStep(getCurrentStepFromURL());
}
